var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.audioPlaylist && _vm.audioPlaylist.length > 0 && _vm.currentUrl)?_c('div',[_c('audio',{ref:"audioTrack",attrs:{"src":_vm.currentUrl},on:{"ended":_vm.nextTrack}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }